module.exports = __webpack_public_path__ + "static/media/am.8b42c952.svg";